// John Eldhose 20180629
const RemoveFromCart = (item) => ({
  type: 'REMOVE_FROM_CART',
  item
});

export default RemoveFromCart;



// WEBPACK FOOTER //
// ./src/actions/RemoveFromCart.js